"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _objects = _interopRequireDefault(require("shallow-equal/objects"));

var _DateTimeInputSimple = _interopRequireDefault(require("./DateTimeInputSimple"));

var _Icons = require("./Picker/Icons");

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

require("./DateInputWithDialog.css");

var _dateUtils = require("./dateUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DateInputWithDialog = /*#__PURE__*/function (_Component) {
  _inherits(DateInputWithDialog, _Component);

  var _super = _createSuper(DateInputWithDialog);

  function DateInputWithDialog(props) {
    var _this;

    _classCallCheck(this, DateInputWithDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCalendar", function (e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      _this.setState({
        openDialog: !_this.state.openDialog
      }, function () {
        if (_this.state.openDialog && _this.props.onShow) {
          _this.props.onShow();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (_this.props.autoPop) {
        _this.handleCalendar();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (date) {
      // if(date && this.timeCache){
      // date = new Date(date.getTime());
      // date.setHours(this.timeCache.getHours(), this.timeCache.getMinutes(), this.timeCache.getSeconds());
      // }
      var newState = _this.createState(date);

      _this.setState(newState, function () {
        _this.fireOnChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createState", function (date) {
      var newState = {};

      if (!date) {
        newState.date = null;
        newState.iso = '';
        newState.formatted = '';
      } else {
        newState.date = date;
        newState.iso = date.toISOString();
        newState.formatted = _this.props.gregorian ? (0, _dateUtils.formatGregorian)(date) : (0, _dateUtils.formatJalaali)(date);
      }

      return newState;
    });

    _defineProperty(_assertThisInitialized(_this), "handleEmpty", function () {
      _this.handleDateChange('');
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var newState = {
        date: event.target.date,
        iso: event.target.value,
        formatted: event.target.formatted
      };

      _this.setState(newState, function () {
        _this.fireOnChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fireOnChange", function () {
      if (_this.props.onChange) {
        var e = {
          target: {
            name: _this.props.name,
            value: _this.state.iso,
            formatted: _this.state.formatted,
            date: _this.state.date
          }
        };

        _this.props.onChange(e);
      }
    });

    _this.inputRef = /*#__PURE__*/_react.default.createRef();
    var _date = null;

    if (props.value) {
      _date = new Date(props.value);
      _this.timeCache = _date;

      if (_date.toString() === 'Invalid Date') {
        _date = null;
      }
    }

    _this.state = _this.createState(_date);
    _this.state.openDialog = false;
    return _this;
  }

  _createClass(DateInputWithDialog, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.value) {
        this.timeCache = new Date(nextProps.value);
      }

      if (nextProps.value !== this.state.iso || nextProps.value !== this.props.value || nextProps.gregorian !== this.props.gregorian || nextProps.ltr !== this.props.ltr || nextProps.numberFormat !== this.props.numberFormat) {
        return true;
      }

      if (!(0, _objects.default)(nextProps.style, this.props.style)) {
        return true;
      }

      if (nextProps.className !== this.props.className) {
        return true;
      }

      if (nextProps.disabled !== this.props.disabled) {
        return true;
      }

      if (nextProps.readOnly !== this.props.readOnly) {
        return true;
      }

      if (nextState.openDialog !== this.state.openDialog) {
        return true;
      }

      if (nextProps.placeholder !== this.props.placeholder) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          className = _this$props.className,
          value = _this$props.value,
          dialogContainerStyle = _this$props.dialogContainerStyle,
          dialogContainerClassName = _this$props.dialogContainerClassName,
          closeLabel = _this$props.closeLabel,
          autoOk = _this$props.autoOk,
          onDismiss = _this$props.onDismiss,
          style = _this$props.style,
          filterDate = _this$props.filterDate,
          gregorian = _this$props.gregorian,
          ltr = _this$props.ltr,
          onChange = _this$props.onChange,
          autoPop = _this$props.autoPop,
          rest = _objectWithoutProperties(_this$props, ["disabled", "readOnly", "className", "value", "dialogContainerStyle", "dialogContainerClassName", "closeLabel", "autoOk", "onDismiss", "style", "filterDate", "gregorian", "ltr", "onChange", "autoPop"]);

      var date = this.state.date;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.inputRef,
        className: "date-input-with-dialog-main",
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement(_DateTimeInputSimple.default, _extends({
        className: "date-input-with-dialog-input".concat(ltr ? ' ltr' : '', " ").concat(this.props.className ? this.props.className : ''),
        gregorian: gregorian,
        disabled: disabled,
        readOnly: readOnly,
        value: value,
        onShowDialog: this.handleCalendar,
        onChange: this.handleChange
      }, rest)), /*#__PURE__*/_react.default.createElement("div", {
        className: "date-input-with-dialog-input-buttons date-input-with-dialog-calendar".concat(ltr ? ' ltr' : ''),
        onClick: this.handleCalendar
      }, /*#__PURE__*/_react.default.createElement(_Icons.CalendarIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "date-input-with-dialog-input-buttons date-input-with-dialog-empty".concat(ltr ? ' ltr' : ''),
        onClick: this.handleEmpty
      }, /*#__PURE__*/_react.default.createElement(_Icons.DeleteIcon, null)), this.state.openDialog && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        divRef: this.inputRef,
        gregorian: gregorian,
        onChange: function onChange(e) {
          _this2.handleDateChange(e.target.value);

          if (autoOk) {
            _this2.handleCalendar();
          }
        },
        cancelHandler: this.handleCalendar,
        selectedDay: date,
        style: dialogContainerStyle,
        className: dialogContainerClassName,
        closeLabel: closeLabel,
        onDismiss: onDismiss,
        filterDate: filterDate,
        ltr: ltr,
        pickTime: true
      })));
    }
  }]);

  return DateInputWithDialog;
}(_react.Component);

_defineProperty(DateInputWithDialog, "propTypes", {
  /**
   * The name that will be set while firing the onChange event in the target object
   */
  name: _propTypes.default.string,

  /**
   * The number format to show 'FARSI' / 'LATIN'
   */
  numberFormat: _propTypes.default.string,

  /**
   * Callback function that is fired when the date value changes.
   * @param {string} date and time, The new date and time in iso 8601 format like 2018-08-23T21:06:50Z
   * it is always UTC
   */
  onChange: _propTypes.default.func,

  /**
   * If true, automatically accept and close the picker on select a date.
   */
  autoOk: _propTypes.default.bool,

  /**
   * Override the default text of the 'OK' button.
   */
  closeLabel: _propTypes.default.node,

  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes.default.object,

  /**
   * The css class name of the root element.
   */
  className: _propTypes.default.string,

  /**
   * Override the inline-styles of DatePickerDialog's Container element.
   */
  dialogContainerStyle: _propTypes.default.object,

  /**
   * Override the inline-styles of DatePickerDialog's Container element.
   */
  dialogContainerClassName: _propTypes.default.object,

  /**
   * Disables the DateTimeInput.
   */
  disabled: _propTypes.default.bool,

  /**
   * makes the DateTimeInput readonly.
   */
  readOnly: _propTypes.default.bool,

  /**
   * Callback function that is fired when a click event occurs on the Date Picker's `TextField`.
   * @param {object} event Click event targeting the `main div element`.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function that is fired when the Date-Time input's dialog is dismissed.
   */
  onDismiss: _propTypes.default.func,

  /**
   * Callback function that is fired when the Date-Time input's `main div` gains focus.
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the Date-Time input's dialog is shown.
   */
  onShow: _propTypes.default.func,

  /**
   * a function to filter some dates, return true means that it accept the date and false is to reject it. It gives a date 'jYYYY/jMM/jDD' format as the first parameter.
   */
  filterDate: _propTypes.default.func,

  /**
   * makes the DateInput gregorian.
   */
  gregorian: _propTypes.default.bool,

  /**
   * makes the DateInput left to right.
   */
  ltr: _propTypes.default.bool,

  /**
   * pop the date (time) dialog by clicking on the input.
   */
  autoPop: _propTypes.default.bool,

  /**
   * Sets the value for the Date-Time input.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)])
});

var _default = DateInputWithDialog;
exports.default = _default;